module.exports = __webpack_public_path__ + "img/Female_Tenant_W_Coffee.90bf3e3.png";